import {validate} from '../../../lib/schema-validator.js'
import {valueSchema, answerSchema} from './schema.js'

export const DATA_POINT_ID = 'are_wkrs_informed_terms_cond_surrounding_granting_repayment'

export const dataPointDefinition = {
  retracedId: 'are_wkrs_informed_terms_cond_surrounding_granting_repayment',
  name: 'Are workers informed of the terms and conditions surrounding the granting and repayment of advances and loans?',
  description:
    'The intent of this question is to understand if workers are fully informed of the TERMS of the loan and/or advance. For both the granting process (the initial loan giving) and the re-payment process (how and when loans are to be paid back.) ',
  meta: {
    slcpMeta: {
      key: 'wb-17--2',
      number: 'WB-WAGE-115',
      masterType: 'Question',
      versionImported: '1.7.0',
    },
  },
  fieldTypeId: 'SHORT_TEXT',
  type: 'RELATIONAL',
  options: [],
  schema: {
    type: 'object',
    properties: {
      value: {
        type: 'string',
      },
    },
    required: ['value'],
  },
  externalIds: [{id: 'wb-17--2', version: '1.7.0', provider: 'slcp'}],
  sortingId: 35110,
  sectionId: '',
  impactArea: '',
  impactAreaId: '',
}

export const validateSchema = data => {
  try {
    validate({value: data, schema: valueSchema})
    return data
  } catch (error) {
    throw new Error(`DATA_POINT_ID: ${error}`)
  }
}
export const transformAnswer = (answer, {meta}) => {
  try {
    validate({value: answer, schema: answerSchema})
    const formattedDataPointKey = DATA_POINT_ID.replace(/_([a-z])/g, g => g[1].toUpperCase())
    return {[formattedDataPointKey]: answer}
  } catch (error) {
    throw new Error(`DATA_POINT_ID: ${error}`)
  }
}
